// Types
import type { TBaseImportRow, TImportColumnIndexes } from '~/shared/import/types';
import { EImportParamKey } from '~/shared/import/types';

export class BaseCsvRowGenerator {
  protected generateBasic(
    rawData: string[],
    headerIndexes: TImportColumnIndexes,
    selectedSourceName: string | null,
    processedRowsCount: number,
    index: number
  ): TBaseImportRow {
    return {
      row_num: processedRowsCount + index + 1,
      row_raw_data: rawData.slice(0, rawData.length).join(' '),
      postcode: rawData[headerIndexes[EImportParamKey.POSTCODE]],
      customer_reference: rawData[headerIndexes[EImportParamKey.CUSTOMER_REFERENCE]],
      crm_link: rawData[headerIndexes[EImportParamKey.CRM_LINK]],
      last_activity: rawData[headerIndexes[EImportParamKey.LAST_ACTIVITY]],
      last_valuation: rawData[headerIndexes[EImportParamKey.LAST_VALUATION]],
      last_letting_valuation: rawData[headerIndexes[EImportParamKey.LAST_LETTING_VALUATION]],
      source: selectedSourceName || rawData[headerIndexes[EImportParamKey.SOURCE]],
      contact_type: rawData[headerIndexes[EImportParamKey.CONTACT_TYPE]],
      contact_reference: rawData[headerIndexes[EImportParamKey.CONTACT_REFERENCE]],
      contact_name: rawData[headerIndexes[EImportParamKey.CONTACT_NAME]],
      contact_email: rawData[headerIndexes[EImportParamKey.CONTACT_EMAIL]],
      contact_marketing_consent: rawData[headerIndexes[EImportParamKey.CONTACT_MARKETING_CONSENT]],
      contact_mobile_phone: rawData[headerIndexes[EImportParamKey.CONTACT_MOBILE_PHONE]],
      contact_work_phone: rawData[headerIndexes[EImportParamKey.CONTACT_WORK_PHONE]],
      contact_home_phone: rawData[headerIndexes[EImportParamKey.CONTACT_HOME_PHONE]],
      contact_created: rawData[headerIndexes[EImportParamKey.CONTACT_CREATED]],
      created: rawData[headerIndexes[EImportParamKey.RECORD_CREATED_DATE]],
    };
  }
}
